const WelcomeHumanImg = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Livello_1"
        x={0}
        y={0}
        style={{
            enableBackground: "new 0 0 158 110",
        }}
        viewBox="0 0 158 110"
        {...props}
    >
        <style>
            {
                ".st12,.st13,.st3,.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#d4a181}.st12,.st13,.st4{fill:#191847}.st12,.st13{fill:#89c5cc}.st13{fill:#69a1ac}"
            }
        </style>
        <g id="Dashboard">
            <g id="_x37_68-_x2F__x2F_-Filled_x2F__x2F_-Tenant" transform="translate(-526 -167)">
                <g id="Group" transform="translate(526.005 167.122)">
                    <g id="Background" transform="translate(0 12.254)">
                        <path
                            id="Weird-Shape"
                            d="M5.9 10c7-15.6 51.2-12.7 64.8 7.5s-1.9 65.3-15.9 65.3-14-30.4-19.7-39.4S-1.1 25.6 5.9 10z"
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: "#b9e6f6",
                                fillOpacity: 0.8,
                            }}
                        />
                        <path
                            id="Weird-Shape_00000139986942535642407590000010668141716253857408_"
                            d="M10.3 54.6c3.8 7.5 10.5 1.8 19.1-6.1S49 32.7 45.2 25.2s-17.5-6.5-26.1 1.5-12.6 20.4-8.8 27.9z"
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: "#c9d9e8",
                                fillOpacity: 0.8,
                            }}
                        />
                        <path
                            id="Weird-Shape_00000137818826173318833460000000965759502650162348_"
                            d="M68 76.9c5.6 0 11.8-5.3 11.8-12.1S73.6 52.6 68 52.6s-7.7 7.8-7.7 13.4 2.1 10.9 7.7 10.9z"
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: "#00c3ea",
                                fillOpacity: 0.8,
                            }}
                        />
                    </g>
                    <g id="A-Human_x2F_Sitting" transform="translate(21.762 38.742)">
                        <g id="Head_x2F_Front" transform="translate(15.58)">
                            <path
                                id="Head"
                                d="M8.4 2c1.3 2.4 1.1 8.3-.5 8.8-.7.2-2.1-.2-3.5-1.1l.9 6.3H0l1.8-8.4C.8 6.4.1 5 .2 3.3.6-1.4 7.1-.4 8.4 2z"
                                className="st3"
                                transform="translate(.024 .794)"
                            />
                            <path
                                id="Hair"
                                d="M.6 2.9C1.8-2 8.7 1 10 .2c.3 1.8-.7 3.2-3.9 2.9-.7.4-1.2 1.2-1.9 2.2-.1-.1-.3-.1-.4-.1-.8 0-1.4.6-1.4 1.3 0 .4.2.7.4.9-.3.4-.6.9-1 1.3C.3 7.9-.7 5.4.6 2.9z"
                                className="st4"
                            />
                        </g>
                        <g id="Bottom_x2F_Skinny-Jeans-1" transform="translate(0 34.873)">
                            <g id="Seat-Stuff">
                                <path
                                    d="M6.1 0h17l2.2 27.1H0z"
                                    style={{
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        fill: "#c5cfd6",
                                    }}
                                    transform="translate(0 9.175)"
                                />
                                <path
                                    d="M6.1 0h5.2l3.1 27.1H0z"
                                    style={{
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        fillOpacity: 0.1,
                                    }}
                                    transform="translate(0 9.175)"
                                />
                            </g>
                            <path
                                id="Skin"
                                d="M42.4 4.5c1.8-1.1 4.8.3 4.8 1.9 0 2.2-.9 8.2-2 14l-.1.9c-1.1 6.3-2.2 12.2-2.4 12.9-.2 1.4-2.6 1.7-2.7 0-.2-2.8-.6-12.3-.2-16.8.2-1.8.4-3.6.5-5.1-2.2 4-5.7 9.7-10.3 17.2l-2.5-1.1c2-6.5 3.6-11.1 4.9-13.8 2.2-4.6 4.2-8.5 5.1-9.9 1.3-2.2 3.7-1.5 4.9-.2z"
                                className="st3"
                            />
                            <path
                                id="LegLower"
                                d="m27.7 24.7 8.7-20.5c2.1-3.3 7.9.7 7.2 2.6-1.6 4.4-9.8 18.6-10.3 19.9l-5.6-2z"
                                style={{
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    fill: "#005075",
                                }}
                            />
                            <g id="Right-Shoe" transform="rotate(30 -33.917 63.855)">
                                <path
                                    id="Shoe"
                                    d="M0 4.6.2 0h4.6c2.2 1.5 5 2.8 8.6 3.7v.9H5l-2.8-.4v.4H0z"
                                    className="st4"
                                />
                            </g>
                            <g
                                id="Right-Shoe_00000102537689992544867940000015767477422512263575_"
                                transform="translate(38.901 31.676)"
                            >
                                <path
                                    id="Shoe_00000078031881454398002740000009619309667871229068_"
                                    d="M0 4.6.2 0h4.6c2.2 1.5 5 2.8 8.6 3.7v.9H5.1l-2.9-.4v.4H0z"
                                    className="st4"
                                />
                            </g>
                            <path
                                id="Leg-and-Butt"
                                d="M47.9 8c0 5.8-2.8 19.3-2.8 20.6h-6c.9-12.1 1.2-18.2.9-18.3-.4-.2-15.6 1.5-20.2 1.5-6.6 0-9.3-4.1-9.5-11.8h13.1C26 .3 39.9 3.1 45 4c2.3.4 2.9 2.4 2.9 4z"
                                style={{
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    fill: "#0090d1",
                                }}
                            />
                        </g>
                        <g id="Body_x2F_Long-Sleeve-1" transform="translate(8.116 7.299)">
                            <path
                                id="Skin_00000033335298296799153180000011790330392326043826_"
                                d="m24.5 5.1 8.3-2.5c1.6-1.2 3-2.1 4.4-2.6.4-.1 1.1 0 .2.9-.8.9-1.7 2-1.4 2.3.2.4 1.1.1 1.3.7.2.4-1.3.7-4.3.9l-6.5 3.8-2-3.5zm-.7 14.6 7 5.1c1.9.5 3.5 1.1 4.8 1.9.3.3.7.8-.6.7-1.2-.1-2.6-.1-2.7.3s.6.9.2 1.5c-.2.4-1.3-.6-3.3-2.9l-6.9-2.9 1.5-3.7z"
                                className="st3"
                            />
                            <path
                                id="Coat-Back"
                                d="M12.9 6c3.8 7.1 9.3 12.5 17.3 18.1l-3 3.4c-8.9-3.3-13.7-5.3-16-12-.6-1.7-1-7-1.3-9.8l3 .3z"
                                style={{
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    fill: "#2f3676",
                                }}
                            />
                            <path
                                id="Shirt"
                                d="M2.2 29.5h16.9c-3.8-11.6-5.8-19.6-5.9-23.9 0-.2-.4-.6-.6-.6-1.3.4-2.7.2-4.3-.4C4.4 11 3 18.9 2.2 29.5z"
                                style={{
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    fill: "#f2f2f2",
                                }}
                            />
                            <path
                                id="Coat-Front"
                                d="m31.6 2.7.9 4.5c-6.9 4.4-13.8 7.8-19.9 7.3C15.2 25.8 15.1 35 9.3 35h-9c-1.4-9.6 2.3-22.8 5.8-29.5.1-.3.4-.7 1.1-.7h2.6c4.9-.1 12.8.8 21.8-2.1z"
                                className="st4"
                            />
                        </g>
                    </g>
                    <g
                        id="Cells"
                        style={{
                            opacity: 0.5,
                        }}
                        transform="translate(90.309)"
                    >
                        <path
                            id="Fill-5"
                            d="M.6 1.2c-.9.7-.5 3.3-.6 4.2 0 1.5.1 3 .2 4.5.1 1 .6 10.5 2.1 9.8.8-.4.3-3.2.3-4 0-1.9-.1-3.9-.2-5.8-.1-1.8-.2-3.6-.1-5.4 0-.4.5-5.3-1.7-3.3"
                            className="st12"
                        />
                        <path
                            id="Fill-7"
                            d="M33 0c-6.4.1-12.7.4-19.1.6-3.1.1-6.1.2-9.2.4-1 0-3.2-.3-4.1.2-1.9 1.2 1.2 1.5 2 1.5 12.6-.5 25.2-1 37.8-1.1 6.2 0 12.4.2 18.5.1 2.4 0 5-1 5.6 1.7.7 3.1-.1 6.5-.3 9.6-.1 2.1-.1 4.1 0 6.1.1 1.3-.1 2.8.1 4.1.2 1.2 1.1 2 2 .6.5-.8.2-2.9.3-3.9V16c0-3.2.5-6.3.4-9.5 0-2.1-.1-5.8-2.8-6.3-2.9-.5-6.4 0-9.3 0C47.6.2 40.3 0 33 0"
                            className="st12"
                        />
                        <path
                            id="Fill-9"
                            d="M15.4 19.7c-2.4 0-4.8 0-7.1.1-2 0-5.2-.4-7.1.3-1.3.5-1.6 2 0 2.4 1.8.4 4.5-.3 6.4-.3 9.4-.2 18.9-.4 28.3.2 8.8.6 17.8 1.1 26.6.5.7-.1 4.5-.2 2.8-1.7-1-.8-5.1-.3-6.4-.3-4.6-.1-9.2-.2-13.8-.4-4.6-.2-9.1-.7-13.6-.8-5.5-.1-10.8 0-16.1 0"
                            className="st12"
                        />
                        <path
                            id="face"
                            d="M13 6.4c3.7.2 7.4 5.4 3.6 7.9-3.5 2.4-10.1-.2-8.2-4.8-.3.7.4-.7.4-.7.4-.4 1-.9 1.5-1.2.5-.4 1.1-.8 1.7-1 .5-.2.4.3 1-.2m-1.8-1.9c-1.7.7-2.5 1.4-3.7 2.7-.8 1-1.9 1.5-1.9 2.7 0 .3.4.6.4.9.1.4 0 .8.1 1.2.7 4.1 5.7 5.4 9.4 4.7 3.2-.7 5.6-3.6 4.8-6.9-.7-3.2-5.7-6.6-9.1-5.3"
                            className="st12"
                        />
                        <path
                            id="Fill-13"
                            d="M9.9 10.2c0 1.4 2.1 1.4 2.1 0s-2.1-1.4-2.1 0"
                            className="st12"
                        />
                        <path
                            id="Fill-15"
                            d="M12.7 10.2c0 1.4 2.1 1.4 2.1 0s-2.1-1.4-2.1 0"
                            className="st12"
                        />
                        <path
                            id="Fill-17"
                            d="M13.5 12.7c-.6.2-1.4-.2-1.9.1-.9.5 0 .9.5 1.1 2.1.9 2.5-1.6 1.4-1.2"
                            className="st12"
                        />
                        <path
                            id="Fill-19"
                            d="M45.9 9.1c0 .1-.3.1 0 0m-9.2-1.3c-1.6.3-2.9 1.8-4.7 1.6-1.3-.1-2.2-1.4-3.5-1.5-1.7-.2-6.2 3.4-3.8 4.1 1.4.4 2.2-2.1 3.4-2.2 1-.1 2.3 1 3.3 1.2 1.9.3 3.2-.7 4.8-1.3 1.8-.7 2.8-.1 4.4.7 1.2.6 2.4 1 3.8.8 1.3-.2 3-1.5 4.3-1.4 1.3.1 2.2 1.4 3.6 1.6.6 0 1.4.2 1.3-.6-.1-.7-.8-.5-1.3-.8-1.2-.6-2.4-1.7-3.9-1.6-1.1.1-2.1.8-3.2 1.2-3.3 1-5.2-2.5-8.5-1.8"
                            className="st12"
                        />
                        <path
                            id="Fill-21"
                            d="M39.4 29.6c-6.5.1-13 .1-19.4.6-1.5.1-17.2 1.5-17.1 1.6.1.2 2.1.5 2.1.5-.3-.3-.6-.4-1.1-.3 14.8 0 29.6-1.3 44.5-1 3.7.1 7.5 0 11.2.1.9 0 3.2.7 4 .3 1.9-1.1-1.6-1.2-2.1-1.2-7.3-.6-14.8-.7-22.1-.6"
                            className="st13"
                        />
                        <path
                            id="Fill-23"
                            d="M.4 32.8c-1 1-.1 4.5 0 5.8.1 1.9 0 3.8.2 5.7.2 2.2.5 4.5 1 6.6.3 1.2 1.4 3 1.8.9.3-1.5-.2-3.5-.3-5-.2-2-.3-4.1-.3-6.1 0-1.8 0-3.6-.2-5.4 0-1-.5-4.1-2.2-2.5"
                            className="st13"
                        />
                        <path
                            id="Fill-25"
                            d="M24.9 50.7c-4.6.1-9.3.2-13.9.4-1.9.1-3.8.3-5.7.5-.4 0-4.6.2-2.7 1.6.9.7 4.4-.2 5.6-.3 2-.2 3.9-.3 5.9-.3 4.6-.2 9.1-.3 13.7-.3 8.3.1 16.6.2 24.9 0 1.2 0 10.5.2 10.8-.9.3-.9-3.1-.5-3.7-.5-2.2.1-4.4 0-6.7 0-9.4 0-18.8-.4-28.2-.2"
                            className="st13"
                        />
                        <path
                            id="Fill-27"
                            d="M62.1 30.7c.1 4.1.9 8.3 1.1 12.4l.3 5.7c0 .6-.2 2.1.5 2.4 1 .5 1.1-.5 1.3-1.1.5-1.9.2-4.4.1-6.3 0-1.9-.1-3.8-.2-5.7-.1-1.9-.5-3.8-.7-5.7-.1-.8.2-2.2-.7-2.7-.7-.4-1.8.1-1.7 1"
                            className="st13"
                        />
                        <path
                            id="face_00000090264303996410013210000013452835815123730070_"
                            d="M17 37.5s.1 0 0 0c.1 0 0 0 0 0m-3.9-1.2c1.5.4 2.7.3 4.1 1.3 1.2.9 2.4 2.1 2.7 3.6.9 3.3-2.1 5-5 5.1-2.9 0-7.2-.6-7-4.3.1-2.8 2.2-5.6 5.2-5.7m.1-1.8c-3.8.2-6.9 4.4-6.8 7.9 0 4.3 5 5.4 8.5 5.4 4 0 7.9-2.7 6.8-7-.9-3.5-4.8-6.5-8.5-6.3"
                            className="st13"
                        />
                        <path
                            id="Fill-31"
                            d="M9.2 40.5c0 1.4 2.1 1.4 2.1 0s-2.1-1.5-2.1 0"
                            className="st13"
                        />
                        <path
                            id="Fill-33"
                            d="M13.4 39.7c0 1.4 2.1 1.4 2.1 0 0-1.3-2.1-1.4-2.1 0"
                            className="st13"
                        />
                        <path
                            id="Fill-35"
                            d="M10.8 42.4c-1.3 1.4 3.4 3.9 4.5 1.9.9-1.6-1.1-1.1-1.8-1.2-.8-.1-2.1-1.4-2.7-.7"
                            className="st13"
                        />
                        <path
                            id="Fill-37"
                            d="M45.9 40c-.1 0-.1 0 0 0m-16.4-2c-1.3.2-5.4 1.6-5.5 3-.1 2.6 4-.1 4.8-.4 2.4-.9 3.7 1 6.1 1.1 2.1.1 4-1.6 6-1.4 2.1.2 3.1 2.3 5.4 1.2 1.3-.6 1.2-1.5-.2-1.6-.9-.1-1.4.3-2.3-.1-1.4-.6-2-1.5-3.6-1.3-1.3.1-2.4.8-3.6 1.1-2.9.6-4.4-2-7.1-1.6"
                            className="st13"
                        />
                        <path
                            id="point"
                            d="M55.9 39.9s.1.1 0 0m-1.5-.8c-.1 0-.1 0 0 0m0-.1c.3.2 2.6 1.7.9 2-.8.2-1.5-1.4-.9-2m-.7-1.6c-3.7 1.6.3 7.3 3.2 5 1.2-1 1.4-2.9.2-4-.8-.6-2.5-1.4-3.4-1"
                            className="st13"
                        />
                        <path
                            id="Fill-41"
                            d="M19.7 60.5c-4.5 0-9-.1-13.5.2-.8 0-3.6-.1-4 .7-.7 1.6 2.2.8 2.7.7 8.9-1 18.2-.4 27.2-.1 7.3.2 14.6.4 21.9.8 1.9.1 3.8.2 5.8.4.6 0 2.2.5 2.3-.6.1-1-1.8-.8-2.3-.8-3.9-.2-7.8-.5-11.7-.7-9.5-.6-19-.6-28.4-.6"
                            className="st12"
                        />
                        <path
                            id="Fill-43"
                            d="M2 62.4c-.8.8-.4 4-.4 5 0 1.8-.1 3.6-.2 5.4 0 1.9 0 3.8.1 5.7 0 .8.7 4.6 1.6 2.4.4-1 0-3.7 0-4.8 0-2 .1-4 .2-6.1.1-1.7.1-3.5.2-5.2 0-.5.1-4.2-1.5-2.4"
                            className="st12"
                        />
                        <path
                            id="Fill-45"
                            d="M62.9 78.8c-4.4.4-8.8.2-13.2.5-3.8.3-7.6.4-11.3.5-8.6.2-17.2.3-25.7 1-1.9.2-3.9.3-5.8.4-1 0-5.1-.4-5.4.6-.5 1.7 3.9 1 4.8 1 2.1-.1 4.1-.2 6.2-.4 8.7-.6 17.5-.8 26.2-1.1 4.8-.1 9.5-.5 14.2-.8 2.4-.2 4.7-.2 7.1-.3.6 0 2.8 0 3.3-.4.3-.3.3-1.1-.4-1"
                            className="st12"
                        />
                        <path
                            id="Fill-47"
                            d="M61.4 62.5c.2 4.1.4 8.3.6 12.4 0 1.2-.4 3.5.4 4.6 1.2 1.8 2.1-.1 2.3-1.2.7-3.5-.1-7.3-.2-10.8-.1-1.3.4-4.3-.3-5.5-.8-1.2-2.9-1.1-2.8.5"
                            className="st12"
                        />
                        <path
                            id="hola-:_x29_"
                            d="M54.2 68.3c1.8.4 2 3.9 0 4.2-2.9.3-1.6-3.5 0-4.2m-.5-1.4c-.5 0-1.8-.1-2.1.2-.3.3 0 1 0 1.3-.1 1.1-1.1 1.8-.7 3.1.3.9 1.1 1.8 2.2 2.1 5.3 1.7 5.2-7.6.6-6.7"
                            className="st12"
                        />
                        <path
                            id="Fill-51"
                            d="M12.5 65.2c0-.2 0-.3-.1-.5 2.8 1.3 5 3.7 4.1 6.9-.7 2.5-3.3 3.3-5.7 2.7-2.6-.7-3.9-2.8-3.2-5.4.3-1.2 1.3-2.8 2.6-3.2.7-.2 2.1.3 2.3-.5m-1.6-1c-.7 0-1.4.3-2 .7.5-.4 1.2-.7 2-.7m0-1.6c-1.7.1-2.9 1.1-3.9 2.3-.3.4-1.4 1.4-1.3 1.9.1.4.4 1 1 .6-3.1 6 4.9 11.2 9.8 7 4.5-3.9 0-12-5.6-11.8"
                            className="st12"
                        />
                        <path
                            id="Fill-53"
                            d="M9.2 68.2c0 .9 1.4.9 1.4 0s-1.4-.9-1.4 0"
                            className="st12"
                        />
                        <path
                            id="Fill-55"
                            d="M11.3 68.9c0 .9 1.4.9 1.4 0s-1.4-.9-1.4 0"
                            className="st12"
                        />
                        <path
                            id="Fill-57"
                            d="M12.1 71.7c-.6 0-3-.2-3.4.4-.7.9.4.9 1 1 .5.1 2.6 0 2.9-.4.2-.3.2-1-.5-1"
                            className="st12"
                        />
                        <path
                            id="Fill-59"
                            d="M38.3 69.5c-.1.1-.1.1 0 0m-8.2-.6c-1.3.1-2.5.8-3.7 1.1-1.4.3-2-.3-3.2-.7-1.3-.4-2.2-.2-3.2.6-.6.5-1.9 1.6-1.5 2.5.8 2 2.7-1.2 3.6-1.4 1.4-.2 2.6 1 4.2.6 1.5-.3 2.8-1.3 4.3-1.3 1.3 0 2.5.7 3.7.8 1.9.3 3.2-.4 5-.9 1.5-.4 2.6.1 4.1.6.7.2 2.9 1 2.5-.4-.1-.4-3-1.1-3.5-1.3-1.6-.5-2.6-.3-4.1.3-1.3.5-2.3.7-3.7.4-1.6-.1-2.9-1-4.5-.9"
                            className="st12"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default WelcomeHumanImg;
